export default function createActions(dis, store, restClient) {
  function upsert(payload) {
    dis({ type: 'local/upsert', payload })
  }

  return { upsert }
}
